import { Translation } from 'types/Translation'
import { CreateGroupSchema, EditGroupSchema } from 'validations/GroupSchema'

const defaultValues = {
  name: '',
  nameTranslations: [],
  image: null,
  labelIds: [],
}

const languageCodeSorter = (a: Translation, b: Translation) =>
  (a.languageCode > b.languageCode ? 1 : a.languageCode === b.languageCode ? 0 : -1)

const getSortedNameTranslations = (nameTranslations?: Translation[]) => (
  nameTranslations?.sort(languageCodeSorter)
)

const getValidationSchema = (isEditing: boolean) => (
  isEditing
    ? CreateGroupSchema
    : EditGroupSchema
)

export {
  defaultValues,
  getValidationSchema,
  getSortedNameTranslations
}
